import React, { FC } from 'react';
import { GlobeIcon } from '@getgo/chameleon-icons/react';
import { IconButton, Typography, TooltipV2 } from '@getgo/chameleon-web/react';
import { IEventDetail } from '../eventInterface';
import { ReactComponent as Facebook } from './../../../svg/ic_facebook.svg';
import { ReactComponent as GoTo } from './../../../svg/ic_goto.svg';
import { ReactComponent as Linkedin } from './../../../svg/ic_linkedin.svg';
import { ReactComponent as Twitter } from './../../../svg/ic_twitter.svg';
import './../styles/social-media-color.scss';
import FormatStringUrl from '../../utils/formatStringUrl';
import { useTranslation } from 'react-i18next';
import { onClickOfEventSocialMediaLinkTracker } from '../../../mixpanel/Feature/eventTracker';
export interface EventHostedByDetailsProps {
  eventDetail: IEventDetail;
}

const EventHostedByDetails: FC<EventHostedByDetailsProps> = ({
  eventDetail: { ownerKey, organizers, metadata, companyBio, eventKey },
}) => {
  const { t } = useTranslation();
  const owner = organizers.find((organizer) => organizer?.organizerKey === ownerKey);
  const socialMedialHandler = (socialMediaName: string, link: string) => {
    onClickOfEventSocialMediaLinkTracker({ socialMediaName, link, eventKey });
  };
  const renderSocialMediaIcons = (link: string) => {
    switch (link) {
      case 'WEBSITE':
        return (
          <div className="icon-box">
            <TooltipV2
              position={'bottom-center' as any}
              trigger={
                <IconButton variant="secondary" size="xsmall">
                  <GlobeIcon />
                </IconButton>
              }
            >
              <span className="hosted-tooltip">{t('event.addedSocialMedia.website')}</span>
            </TooltipV2>
          </div>
        );
      case 'FACEBOOK':
        return (
          <div className="icon-box">
            <TooltipV2
              position={'bottom-center' as any}
              trigger={
                <IconButton variant="secondary" size="xsmall">
                  <Facebook />
                </IconButton>
              }
            >
              <span>{t('event.addedSocialMedia.facebook')}</span>
            </TooltipV2>
          </div>
        );
      case 'TWITTER':
        return (
          <div className="icon-box">
            <TooltipV2
              position={'bottom-center' as any}
              trigger={
                <IconButton variant="secondary" size="xsmall">
                  <Twitter />
                </IconButton>
              }
            >
              <span>{t('event.addedSocialMedia.twitter')}</span>
            </TooltipV2>
          </div>
        );
      case 'LINKEDIN':
        return (
          <div className="icon-box">
            <TooltipV2
              position={'bottom-center' as any}
              trigger={
                <IconButton variant="secondary" size="xsmall">
                  <Linkedin />
                </IconButton>
              }
            >
              <span>{t('event.addedSocialMedia.linkedin')}</span>
            </TooltipV2>
          </div>
        );
      case 'GOTOSTAGE':
        return (
          <div className="icon-box">
            <TooltipV2
              position={'bottom-center' as any}
              trigger={
                <IconButton variant="secondary" size="xsmall">
                  <GoTo />
                </IconButton>
              }
            >
              <span>{t('event.addedSocialMedia.gotostage')}</span>
            </TooltipV2>
          </div>
        );
    }
  };
  return (
    <div className="event-hosted-by-details">
      <div className="event-hosted-by-details-margin-x">
        <Typography variant="body-small" tag="h3" color="text-02">
          {t('event.hostedBy')}
        </Typography>
      </div>
      <div key={owner?.id} className="event-hosted-by-details-margin-x">
        <div className="event-hosted-by-details-organizer">
          <Typography variant="body-large">{owner?.name}</Typography>
        </div>
        <div className="event-hosted-by-details-description">
          <Typography className="preserve-line-breaks" variant="body-medium" color="text-02">
            <FormatStringUrl>{companyBio}</FormatStringUrl>
          </Typography>
        </div>
        <div className="event-hosted-by-details-icon">
          {['WEBSITE', 'TWITTER', 'FACEBOOK', 'LINKEDIN', 'GOTOSTAGE'].map(
            (socialMediaKey: string) =>
              metadata?.[socialMediaKey] && (
                <a
                  target="_blank"
                  rel="noreferrer"
                  key={socialMediaKey}
                  onClick={() =>
                    socialMedialHandler(
                      socialMediaKey.toLowerCase(),
                      metadata?.[socialMediaKey].indexOf('http') > -1
                        ? metadata?.[socialMediaKey]
                        : `http://${metadata?.[socialMediaKey]}`,
                    )
                  }
                  href={
                    metadata?.[socialMediaKey].indexOf('http') > -1
                      ? metadata?.[socialMediaKey]
                      : `http://${metadata?.[socialMediaKey]}`
                  }
                  className="speaker-section-link"
                >
                  {renderSocialMediaIcons(socialMediaKey)}
                </a>
              ),
          )}
        </div>
      </div>
    </div>
  );
};
export default EventHostedByDetails;
